module.exports = __webpack_public_path__ + "static/media/hall-P9.051af75d.svg";